<div class="box-theme">
  <div class="head">
    <div class="body">
      <h2>
        ¡Tu visita ha sido agendada con éxito!<br/>
        Enviaremos un email a:<br/>
        {{email}}<br/>
        con los datos de la reserva.<br/>Te esperamos en {{direccion}}.
      </h2>
    </div>
  </div>
  <div class="body">

    <!-- PASO NUMERO 2 -->
    <div class="paso-2 box-tomade-de-hora">
      <div class="header">
        <h3>
          Al visitar nuestra oficina comercial recuerda que debes:
        </h3>
      </div>
      <div class="body box-recomendaciones">
        <ul>
          <li>
            <div class="thumb">
              <img src="./assets/img/thumb-1.png" alt="Utiliza tu mascarilla" />
            </div>
            <div class="detalle">
              <h4>Utilizar en todo momento tu mascarilla y seguir todas las indicaciones de cuidado y seguridad.</h4>
            </div>
          </li>
          <li>
            <div class="thumb">
              <img src="./assets/img/thumb-2.png" alt="No se permite el ingreso de acompañantes" />
            </div>
            <div class="detalle">
              <h4>No se permite el ingreso con acompañantes</h4>
            </div>
          </li>
          <li>
            <div class="thumb">
              <img src="./assets/img/thumb-3.png" alt="Muestra el correo de confirmación para ingresar" />
            </div>
            <div class="detalle">
              <h4>Para ingresar debes mostrar el correo de confirmación. </h4>
            </div>
          </li>
          <li>
            <div class="thumb">
              <img src="./assets/img/thumb-4.png" alt="Llega con 5 minutos de anticipación" />
            </div>
            <div class="detalle">
              <h4>Te recomendamos llegar con 5 minutos de anticipación para cumplir con la hora agendada.</h4>
            </div>
          </li>
        </ul>
        <div class="callToAcction">
          <input type="button" value="VOLVER" class="btn btn-volver" (click)="irHome()">
        </div>
      </div>
    </div>
  </div>
</div>
